import React from 'react'
import gql from 'graphql-tag'
import { connect } from 'react-redux'
import { graphql, compose } from 'react-apollo'
import loadingStatuss from 'actions/LoadingActions'
import { Raksts } from 'pages'

// FIXME: Identisks ar UznemejiemPostDefault, DomeDefault un PageIzsoles

const QUERY = gql`
  query RakstsQuery($lang: String!, $postId: [Int]!, $parent: [Int]!) {
    current: page(lang: $lang, _id: $postId) {
      _id
      title
      path
      parent
      content
      date_created
      date_modified
      subpages_pages {
        _id
        title
        path
        parent
        content
        acf
      }
      acf
    }
    parent: page(lang: $lang, _id: $parent) {
      _id
      title
      path
      subpages_pages {
        _id
        title
        path
        parent
        content
        acf
      }
      acf
    }
    teksti(lang: $lang, _id:[
      "publicets",
      "atjaunots",
      "atpakal",
      "talak",
      "apskatit_attelu_originalizmera"
    ]) {
      _id
      text
    }
  }
`;

const queryOptions = {
  options: ({ lang, postId, init_page }) => ({
    fetchPolicy: 'cache-first',
    variables: {
      lang: (lang || 'lv'),
      postId: (init_page.rewrite_id ? init_page.rewrite_id : postId),
      parent: init_page.parent,
      path: init_page.path,
    }
  }),
  props: props => {
    const { data: {
      loading,
      variables: { path },
      current,
      parent,
      teksti,
      ...rest
    } } = props;

    return {
      loading,
      data: {
        path,
        current,
        parent,
        subpages: (current && current.length) ? current[0].subpages_pages : (parent && parent.subpages_pages.length) ? parent[0].subpages_pages : [],
        teksti,
      }
    }
  }
}

class UznemejiemPostDefault extends React.PureComponent {
  componentWillMount() {
    const {
      path,
      loading,
      loadingStatuss,
      global_loading,
    } = this.props;

    if (loading) {
      loadingStatuss({ _id: path + '__', loading: true });
    } else if (!loading && global_loading && global_loading[path + '__'] === true) {
      loadingStatuss({ _id: path + '__', loading: false });
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      path,
      loading,
      loadingStatuss,
      global_loading,
    } = nextProps;

    if (loading && global_loading && global_loading[path + '__'] === false) {
      loadingStatuss({ _id: path + '__', loading: true });
    } else if (!loading && global_loading && global_loading[path + '__'] === true) {
      loadingStatuss({ _id: path + '__', loading: false });
    }
  }

  render() {
    const {
      loading,
      data,
      lang,
      history,
    } = this.props;

    if (loading) {
      return null;
    }

    return (
      <Raksts data={data} lang={lang} path={history.location.pathname} />
    );
  }
}


const mapStateToProps = (state) => ({
  global_loading: state.global_loading,
});

const mapDispatchToProps = (dispatch) => ({
  loadingStatuss: (LOADING) => {
    dispatch(loadingStatuss(LOADING));
  }
});

export default compose(
  graphql(QUERY, queryOptions),
  connect(mapStateToProps, mapDispatchToProps),
)(UznemejiemPostDefault);



// WEBPACK FOOTER //
// ./src/components/UznemejiemPostDefault.js